export default __webpack_public_path__ + "static/media/Clan Bound Fauld of Passing Spirits.c636563c.jpg";